import {
    useEffect,
} from 'react'
import {
    CircularProgress,
} from '@mui/material'
import {
    RequestConfigFunction,
} from 'app/types/request.types'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import {
    TableFilterParams,
} from 'app/types/common.types'
import Button from 'app/shared-components/Button'
import useSharedStyles from 'app/shared-components/BatchActions/BatchActions.shared.styles'
import useLabel from 'app/hooks/useLabel'

import useFetchBulkData from './hooks/useFetchBulkData'
import useStyles from './ApiDataLoader.styles'

type Props = {
    request: RequestConfigFunction,
    requestKey: RequestKeys
    onLoadData: (data: Record<string, any>[]) => void
    onCancel: () => void
    filterParams: TableFilterParams,
}

const ApiDataLoader = ({
    request,
    requestKey,
    onLoadData,
    filterParams,
    onCancel,
}: Readonly<Props>) => {
    const l = useLabel()
    const {
        classes: sharedClasses,
    } = useSharedStyles()
    const {
        classes,
    } = useStyles()

    const {
        data,
        isComplete,
        cancel,
    } = useFetchBulkData({
        request,
        requestKey,
        filterParams,
    })

    useEffect(() => {
        if (isComplete && data !== null) {
            onLoadData(data)
        }
    }, [
        isComplete,
        data,
        onLoadData,
    ])

    const handleCancel = () => {
        cancel()
        onCancel()
    }

    return (
        <div
            className={sharedClasses.container}
            data-testid="api-data-loader"
        >
            <div className={sharedClasses.loadingContainer}>
                <CircularProgress />
                {l('LOADING_RECORDS')}
            </div>
            <Button
                label={l('CANCEL')}
                secondary
                onClick={handleCancel}
                className={classes.cancelButton}
            />
        </div>

    )
}

export default ApiDataLoader
